// @flow

import React from 'react';

import { Footer as OperationDiameterFooter } from 'operation-diameter';

export const LINKS = [
  {
    title: 'Funding Circle',
    links: [
      {
        href: 'https://www.fundingcircle.com/uk/about-us/',
        title: 'About Us'
      },
      {
        href: 'https://www.fundingcircle.com/uk/careers/',
        title: 'Careers'
      },
      {
        href: 'https://corporate.fundingcircle.com/media/',
        title: 'Media'
      },
      {
        href: 'https://corporate.fundingcircle.com/',
        title: 'Shareholder Information'
      }
    ]
  },
  {
    title: 'Discover more',
    links: [
      {
        href: 'https://www.fundingcircle.com/global/capitalmarkets/',
        title: 'Institutional investors'
      },
      {
        href: 'https://www.fundingcircle.com/uk/introducers/',
        title: 'Introducers'
      },
      {
        href: 'https://www.fundingcircle.com/uk/resources',
        title: 'Tips & Guides'
      },
      {
        href: 'https://corporate.fundingcircle.com/diversity-and-inclusion',
        title: 'Diversity & Inclusion'
      },
      {
        href: 'https://www.fundingcircle.com/uk/partners/developer/api-doc/',
        title: 'Developers'
      }
    ]
  },
  {
    title: 'Support',
    links: [
      {
        href: 'https://www.fundingcircle.com/uk/support/',
        title: 'Help'
      },
      {
        href: 'https://www.fundingcircle.com/uk/support/#contact_our_team_at_funding_circle',
        title: 'Contact us'
      }
    ]
  },
  {
    title: 'Legal Documents',
    links: [
      {
        href: 'https://www.fundingcircle.com/uk/legal/',
        title: 'Legal'
      },
      {
        href: 'https://www.fundingcircle.com/home/security',
        title: 'Security'
      },
      {
        href: 'https://fch-12917-s3.s3.eu-west-2.amazonaws.com/live/7617/1395/4352/Modern_Slavery_Act_Statement_2024_signed.pdf',
        title: 'Modern Slavery Statement'
      }
    ]
  },
  {
    title: 'Other',
    links: [
      {
        href: 'https://www.fundingcircle.com/uk/sitemap/',
        title: 'Sitemap'
      }
    ]
  }
];

type Props = {
  isTrustPilotVisible: boolean
};

const Footer = ({ isTrustPilotVisible = true }: Props) => {
  return (
    <OperationDiameterFooter
      hasLegalSection
      hasRegionSelect={false}
      hasSocialMedia
      hasTrustPilot={isTrustPilotVisible}
      links={LINKS}
    />
  );
};

export default Footer;
